import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastProvider } from 'react-toast-notifications';
import AppRouter from './routers/appRouter';
import theme from './theme';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { BrowserRouter } from 'react-router-dom';

const queryClient = new QueryClient();

function App() {
  return (
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <ToastProvider autoDismiss autoDismissTimeout={3000}>
          <DndProvider backend={HTML5Backend}>
            <BrowserRouter>
              {' '}
              {/* ✅ Router sadece burada */}
              <AppRouter />
            </BrowserRouter>
          </DndProvider>
        </ToastProvider>
      </QueryClientProvider>
    </ChakraProvider>
  );
}

export default App;
